import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Spinner } from "components/ui/spinner";
import SiteShell from "./site/components/SiteShell";
import Home from "./site/pages/Home";
import Services from "./site/pages/Services";
import About from "./site/pages/About";
import Portfolio from "./site/pages/Portfolio";
import RequestManagement from "./site/pages/RequestManagement";
import Privacy from "./site/pages/Privacy";
import NotFound from "./site/pages/NotFound";
const DesignLab = lazy(() => import("./design-lab/DesignLab"));

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/design-lab"
          element={
            <Suspense
              fallback={
                <div className="site-loading">
                  <Spinner />
                </div>
              }
            >
              <DesignLab />
            </Suspense>
          }
        />
        <Route element={<SiteShell />}>
          <Route index element={<Home />} />
          <Route path="services" element={<Services />} />
          <Route path="about" element={<About />} />
          <Route path="portfolio" element={<Portfolio />} />
          <Route path="proposal" element={<RequestManagement />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
